import { render } from "./LogisticsInfo.vue?vue&type=template&id=5ed3b108&scoped=true"
import script from "./LogisticsInfo.vue?vue&type=script&lang=js"
export * from "./LogisticsInfo.vue?vue&type=script&lang=js"

import "./LogisticsInfo.vue?vue&type=style&index=0&id=5ed3b108&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ed3b108"]])

export default __exports__